import { AragingmanagementreportComponent } from './../../app/views/profitability-utilization/aragingmanagementreport/aragingmanagementreport.component';
import { InvoicecancellogComponent } from './../../app/views/dashboard/invoicecancellog/invoicecancellog.component';
import { CreatemanualpaymentComponent } from './../../app/views/dashboard/createmanualpayment/createmanualpayment.component';
import { ReceipthistorylistComponent } from './../../app/views/dashboard/receipthistorylist/receipthistorylist.component';
import { InvoicelistComponent } from './../../app/views/dashboard/invoicelist/invoicelist.component';
import { RoleGuard } from './../../app/views/role.guard';
import { InvoiceComponent } from './../../app/views/dashboard/invoice/invoice.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SalesReportsComponent } from '../../app/views/sales/sales-reports/sales-reports.component';
import { ErpSalesOrdersComponent } from '../../app/views/sales/erp-sales-orders/erp-sales-orders.component';
import { ErpPostedsalesorderComponent } from '../../app/views/sales/erp-postedsalesorder/erp-postedsalesorder.component';

const routes: Routes = [
  {
    path: 'invoice',
    component: InvoiceComponent,
    canActivate: [RoleGuard],
    data: { allowedRoles: [1, 2, 3, 5, 8] }
  },
  {
    path: 'invoice-list',
    component: InvoicelistComponent,
    canActivate: [RoleGuard],
    data: { allowedRoles: [1, 2, 3, 5, 8] }
  },
  {
    path: "manual-payment",
    component: CreatemanualpaymentComponent,
    canActivate: [RoleGuard],
    data: { allowedRoles: [1, 2, 3, 5] }
  },
  {
    path: "receipt-history",
    component: ReceipthistorylistComponent,
    canActivate: [RoleGuard],
    data: { allowedRoles: [1, 2, 3, 5] }
  },
  /* {
    path: "cancelinvoicelog",
    runGuardsAndResolvers: "always",
    component: InvoicecancellogComponent,
    data: { title: "Invoice Cancellation Log" },
  }, */
  {
    path: "ar-aging",
    runGuardsAndResolvers: "always",
    component: AragingmanagementreportComponent,
    data: { title: "A/R Aging" },
  },
  {
    path: "sales-report",
    runGuardsAndResolvers: "always",
    component: SalesReportsComponent,
    data: { title: "sales-report" },
  },
  {
    path: "sales-order",
    runGuardsAndResolvers: "always",
    component: ErpSalesOrdersComponent,
    data: { title: "sales-report" },
  },
  {
    path: "sales-invoices",
    runGuardsAndResolvers: "always",
    component: ErpPostedsalesorderComponent,
    data: { title: "sales-report" },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SalesRoutingModule { }
